import { render, staticRenderFns } from "./CaregiverLayout.vue?vue&type=template&id=7d513d87"
import script from "./CaregiverLayout.vue?vue&type=script&lang=js"
export * from "./CaregiverLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports